
	import { Component, Vue } from 'vue-property-decorator';
	import PatientRecall from '@/views/patient-table/PatientRecall.vue';
	import GetStartedView from '@/views/getting-started/GetStartedView.vue';
	import SplashScreen from '@/views/getting-started/SplashScreen.vue';
	import { Observer } from 'mobx-vue';
	import { WEIGHT_TYPE } from '@/store/patientStore';

	@Observer
	@Component({
		components: {}
	})
	export default class WeightInput extends Vue {
		private invalid = false;
		private WEIGHT_TYPE = WEIGHT_TYPE;
		private validateWeight() {
			const reg = /^\d+$/;

			this.$state._patient.patientUIData.weight.value =
				this.$state._patient.patientUIData.weight.value === '' ? '' : parseFloat((this.$state._patient.patientUIData.weight.value || 0).toFixed(1));
		}
	}
